import Navigation from '../Navigation';
import { Outlet } from 'react-router-dom';
import { Customer } from '../../types/customer';

interface Props {
  customer?: Customer;
}

function Layout(props: Props): JSX.Element {
  return (
    <div className='layout min-h-full pb-5 bg-gray-200'>
      <header>
        <Navigation customer={props.customer} />
      </header>

      <Outlet />
    </div>
  );
}

export default Layout;
